module.exports = __webpack_public_path__ + "static/about-206c5354e2ffa6edd1171f84be1ef245.png";